// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ud-stat-card {
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  box-shadow: 0 2px 16px rgba(25, 28, 30, 0.07);
  border: 1px solid rgba(73, 69, 79, 0.08);
}

.ud-stat-card .ud-bg-icon {
  position: absolute;
  right: -12px;
  bottom: -12px;
  font-size: 5rem;
  line-height: 1;
  opacity: 0.06;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.ud-stat-card:hover .ud-bg-icon {
  opacity: 0.1;
}

.ud-section-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 16px rgba(25, 28, 30, 0.07);
  border: 1px solid rgba(73, 69, 79, 0.08);
  overflow: hidden;
}

.ud-section-card-header {
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid rgba(73, 69, 79, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ud-spec-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(73, 69, 79, 0.06);
  margin-bottom: 0.75rem;
}

.ud-spec-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.ud-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.ud-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.75rem;
}

.ud-ledger-table th {
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #79747e;
  padding: 0.75rem 1.5rem;
  background: #f7f2fa;
  border-bottom: 1px solid rgba(73, 69, 79, 0.08);
}

.ud-ledger-table td {
  padding: 0.875rem 1.5rem;
  border-bottom: 1px solid rgba(73, 69, 79, 0.06);
  vertical-align: middle;
}

.ud-ledger-table tbody tr:last-child td {
  border-bottom: none;
}

.ud-ledger-table tbody tr:hover {
  background: #faf7ff;
}

.ud-contract-highlight {
  background: linear-gradient(135deg, #4b38b3 0%, #6549d5 100%);
  border-radius: 12px;
  padding: 1.5rem;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.ud-contract-highlight .ud-bg-icon {
  position: absolute;
  right: -16px;
  bottom: -16px;
  font-size: 6rem;
  opacity: 0.12;
  pointer-events: none;
}

.ud-client-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f7f2fa;
  border-radius: 10px;
}

.ud-client-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4b38b3, #6549d5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  flex-shrink: 0;
}

.ud-mini-stat {
  flex: 1 1;
  padding: 0.875rem 1rem;
  background: #f7f2fa;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Inventory/Unit/Detail/css/UnitDetail.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".ud-stat-card {\n  position: relative;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 16px rgba(25, 28, 30, 0.07);\n  border: 1px solid rgba(73, 69, 79, 0.08);\n}\n\n.ud-stat-card .ud-bg-icon {\n  position: absolute;\n  right: -12px;\n  bottom: -12px;\n  font-size: 5rem;\n  line-height: 1;\n  opacity: 0.06;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.ud-stat-card:hover .ud-bg-icon {\n  opacity: 0.1;\n}\n\n.ud-section-card {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 2px 16px rgba(25, 28, 30, 0.07);\n  border: 1px solid rgba(73, 69, 79, 0.08);\n  overflow: hidden;\n}\n\n.ud-section-card-header {\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid rgba(73, 69, 79, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ud-spec-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid rgba(73, 69, 79, 0.06);\n  margin-bottom: 0.75rem;\n}\n\n.ud-spec-row:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.ud-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n.ud-hero {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.75rem;\n}\n\n.ud-ledger-table th {\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #79747e;\n  padding: 0.75rem 1.5rem;\n  background: #f7f2fa;\n  border-bottom: 1px solid rgba(73, 69, 79, 0.08);\n}\n\n.ud-ledger-table td {\n  padding: 0.875rem 1.5rem;\n  border-bottom: 1px solid rgba(73, 69, 79, 0.06);\n  vertical-align: middle;\n}\n\n.ud-ledger-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ud-ledger-table tbody tr:hover {\n  background: #faf7ff;\n}\n\n.ud-contract-highlight {\n  background: linear-gradient(135deg, #4b38b3 0%, #6549d5 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n\n.ud-contract-highlight .ud-bg-icon {\n  position: absolute;\n  right: -16px;\n  bottom: -16px;\n  font-size: 6rem;\n  opacity: 0.12;\n  pointer-events: none;\n}\n\n.ud-client-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f7f2fa;\n  border-radius: 10px;\n}\n\n.ud-client-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4b38b3, #6549d5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.ud-mini-stat {\n  flex: 1;\n  padding: 0.875rem 1rem;\n  background: #f7f2fa;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
